import { map } from "rxjs/operators";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";
import { ModalViewreseauDeSoinDetailComponent } from "src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";
import { ModalViewGarantDetailsComponent } from "src/app/shared/components/modal-view-garant-details/modal-view-garant-details.component";


@Component({
  selector: 'app-bar-prime-tranche-age-statut',
  templateUrl: './bar-prime-tranche-age-statut.component.html',
  styleUrls: ['./bar-prime-tranche-age-statut.component.scss']
})
export class BarPrimeTrancheAgeStatutComponent implements OnInit {

defaultValues: any = {};
@Output() onChangePrimeTrancheAgeStatutForm=new EventEmitter<any>()
// @Input() mode_calcul_prime_id: any;
@Input() currentBareme: any;
@Input() currentProduit: any;
  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  itemsStatutInitialized: any=[];
  filiale_id: any;
  uniteFonctionnelleSelected: any = {};
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 30;
  totalItems: number;
  show_password_field = true;
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "produit";
  title: string = "produit";
  createMessage = "";
  editMessage = "";
  deleteMessage = "";
  itemsParentFonctionnalites = [];
  itemsModeTarification: any = [];
  itemsModeFractionnement: any = [];
  gender = "M";
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite: any = [];
  itemsGenre: any = [];
  itemsFiliale: any = [];
  searchKey: any;
  dateNais: any;
  indiceTab: number = 0;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword = false;
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsTypeGarant: any;
  itemsTypeAssurance: any[];
  itemsModeReconduction: any;
  isTarificationFamille: any;
  bsModalRefPreview: BsModalRef;
  itemsGarant: any;
  itemsGarantProduit: any[];
  currentFamilleGarantieBaremeStatut: any;
  itemsJourAutoriseToSave: any;
  itemToAdd: any = {};
  itemsPrimeByProduit: any = [];
  itemsStatut: any;
  currentData: any;
  itemsReseauDeSoin: any = [];
  is_tarif_famille: boolean;
  itemsGarantie: any;
  itemsChecked: any = [];
  itemsGarantieProduit: any = [];
  current_produit_id: any;
  itemsParamGlobal: any;
  itemsTypeRemboursement: any;
  itemToAddTrancheAge: any = {};
  itemsPrimeByStatutAndTrancheAge: any = [];
  itemsPrimeByTrancheAge: any = [];
  itemToAddStatutTrancheAge: any = {};
  itemsModeCalculPrime: any;
  currentModeCalculPrime: any;
  is_all_checked = false;
  itemsPrimeByProduitId: any=[];

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id;
    let text1 = this.gender == "M" ? "un" : "une";
    this.createMessage =
      "Vous êtes sur le point de créer " + text1 + " " + this.title;
    this.editMessage =
      "Vous êtes sur le point de modifier " + text1 + " " + this.title;
    this.itemToSave.plafond_annuel_famille = 0;
    this.itemToSave.prime_par_famille = 0;

    // this.itemToSave.mode_reconduction_id=''

    setTimeout(() => {
      console.log("here");
      // this.itemToSave.date_effet = new Date()
      // this.itemToSave.date_echeance = new Date((new Date()).getFullYear(), 11, 31, 23, 59, 59, 999);
      // if (this.currentData) {
      //   console.log("currentData: ", this.currentData);

      //   this.itemToSave = Object.assign({}, this.currentData);
      //   this.current_produit_id = this.itemToSave.id;
      // }
    }, 50);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("changes in form prime tranche age statut: ", changes);
    if (changes && changes.currentProduit.currentValue && changes && changes.currentBareme?.currentValue) {
      if(changes.currentBareme?.currentValue.id)
        this.getItemsPlafondConfigTrancheAgeStatutBareme()
      else
        this.getItemsPlafondConfigTrancheAgeStatut()
      
    }
  }

  selectedChangeValue(event: any) {
    console.log("le event selectedChangeValue", event);

    if (!event) this.indiceTab = 0;

    this.indiceTab = event;
  }

  resetForm() {
    this.itemToSave.typeActeId = null;
    this.itemToSave.libelle = "";
    this.itemToAddTrancheAge.age_min = 0;
    if (this.itemsPrimeByTrancheAge && this.itemsPrimeByTrancheAge > 0) {
      this.itemToAddTrancheAge.age_min =
        Math.min(...this.itemsPrimeByTrancheAge.map((r) => r.age_max)) + 1;
    }

    this.itemToAddStatutTrancheAge.age_min = 0;
    if (
      this.itemsPrimeByStatutAndTrancheAge &&
      this.itemsPrimeByStatutAndTrancheAge > 0
    ) {
      this.itemToAddStatutTrancheAge.age_min =
        Math.min(
          ...this.itemsPrimeByStatutAndTrancheAge.map((r) => r.age_max)
        ) + 1;
    }
    // this.itemtad
  }

  

  
  
  
  
  getItemsParametreSysteme() {
    // if(!this.current_produit_id){
    //   return
    // }
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      data: {
        // produit_id: this.current_produit_id
      },
      index: 0,
      size: 10000,
    };

    this.busyGet = this.restClient
      .post("systemeGlobal/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"] && !res["hasError"]) {
            this.itemsParamGlobal = res["items"];
            console.log("itemsParamGlobal: ", this.itemsParamGlobal);
            // this.getItems()
            // this.setDefautValues();
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsParamGlobal = [];
          }
        },
        (err) => {
          this.itemsParamGlobal = [];
        }
      );
  }

  

  findValueInGlobalParams(value) {
    let key = "codification";
    let to_return = "";
    console.log("this.itemsParamGlobal: ", this.itemsParamGlobal);
    if (this.itemsParamGlobal && this.itemsParamGlobal.length) {
      to_return = this.itemsParamGlobal.find(
        (item) => item[key] === value
      ).valeur;
    }
    console.log("to_return: ", to_return);
    return to_return;
  }

  
  

  
  

  

  

  

  

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }



  

  

  

  onAddItemToTableTrancheAgeEtStatut() {
    // Validate if age_max is provided
    debugger
    if (
      this.itemToAddStatutTrancheAge &&
      !this.itemToAddStatutTrancheAge.statut_id
    ) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner statut",
        "top",
        "right"
      );
      return;
    }
    if (
      this.itemToAddStatutTrancheAge &&
      !this.itemToAddStatutTrancheAge.age_max
    ) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner age max",
        "top",
        "right"
      );
      return;
    }

    // Validate if prime is provided
    if (
      this.itemToAddStatutTrancheAge &&
      !this.itemToAddStatutTrancheAge.prime
    ) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner prime",
        "top",
        "right"
      );
      return;
    }

    // Set default age_min if not provided
    if (
      this.itemToAddStatutTrancheAge &&
      !this.itemToAddStatutTrancheAge.age_min
    ) {
      this.itemToAddStatutTrancheAge.age_min = 0;
    }

    // Validate that age_min is smaller than age_max
    if (
      this.itemToAddStatutTrancheAge.age_min >=
      this.itemToAddStatutTrancheAge.age_max
    ) {
      this.utilities.showNotification(
        "snackbar-danger",
        "L'âge minimum doit être inférieur à l'âge maximum",
        "top",
        "right"
      );
      return;
    }

    // Fetch statut_codification from itemsStatut
    if (
      this.itemToAddStatutTrancheAge &&
      this.itemToAddStatutTrancheAge.statut_id
    ) {
      this.itemToAddStatutTrancheAge.statut_codification =
        this.itemsStatut.find(
          (is) => is.id == this.itemToAddStatutTrancheAge.statut_id
        ).codification;
    }

    // Validate for overlaps within the same statut_codification
    const hasOverlap = this.itemsPrimeByStatutAndTrancheAge.some((item) => {
      return (
        item.statut_codification ===
          this.itemToAddStatutTrancheAge.statut_codification && // Match statut_codification
        this.itemToAddStatutTrancheAge.age_min <= item.age_max &&
        this.itemToAddStatutTrancheAge.age_max >= item.age_min
      );
    });

    if (hasOverlap) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Les plages d'âge se chevauchent pour ce statut. Veuillez corriger les valeurs.",
        "top",
        "right"
      );
      return;
    }

    // Add the item to the list if validation passes
    this.itemsPrimeByStatutAndTrancheAge.push(this.itemToAddStatutTrancheAge);

    // Reset itemToAddStatutTrancheAge but retain statut_id
    this.itemToAddStatutTrancheAge = {
      statut_id: this.itemToAddStatutTrancheAge.statut_id,
    };
    this.onInputChange({})
  }
  



  

  
  getItemsStatut() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("statut/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsStatut = _.orderBy(res["items"], ["libelle"], ["asc"]);
            this.itemsStatutInitialized = [...this.itemsStatut];

            console.log(
              "itemsStatutInitialized: ",
              this.itemsStatutInitialized
            );
            this.itemsStatut.sort((a, b) => this.customSort(a, b));

            this.setDefautValues();
          } else {
            this.itemsStatut = [];
          }
        },
        (err) => {
          this.itemsStatut = [];
        }
      );
  }
  getItemsPlafondConfigTrancheAgeStatut() {
    if(!this.currentProduit.id || !this.currentProduit.mode_calcul_prime_id)
      return
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        produit_id:this.currentProduit.id,
        mode_calcul_prime_id:this.currentProduit.mode_calcul_prime_id
        
      },
    };

    this.busyGet = this.restClient
      .post("primeProduit/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsPrimeByProduitId = _.orderBy(res["items"], ["libelle"], ["asc"]);
           
            this.itemsPrimeByProduitId.sort((a, b) => this.customSort(a, b));
            this.onInputChange({})
            this.getItemsPrimeTrancheAgeStatut()

            this.setDefautValues();
          } else {
            this.itemsPrimeByProduitId = [];
          }
        },
        (err) => {
          this.itemsPrimeByProduitId = [];
        }
      );
  }
  refreshListConfig(){
    if(this.currentBareme.id && this.currentProduit.id)
      this.getItemsPlafondConfigTrancheAgeStatutBareme()
    else
      this.getItemsPlafondConfigTrancheAgeStatut()
    
  }
  refreshList(){
    if(this.currentBareme.id && this.currentProduit.id)
      this.getItemsPrimeTrancheAgeStatutBareme()
    else
      this.getItemsPrimeTrancheAgeStatut()
    
  }
  getItemsPlafondConfigTrancheAgeStatutBareme() {
    // debugger
    if(!this.currentProduit.id || !this.currentProduit.mode_calcul_prime_id || !this.currentBareme.id)
      return
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        produit_bareme_id:this.currentProduit.id,
        mode_calcul_prime_id:this.currentProduit.mode_calcul_prime_id,
        bareme_id:this.currentBareme.id
        
      },
    };

    this.busyGet = this.restClient
      .post("primeProduitBareme/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsPrimeByProduitId = _.orderBy(res["items"], ["libelle"], ["asc"]);
           
            this.itemsPrimeByProduitId.sort((a, b) => this.customSort(a, b));
            this.onInputChange({})
            this.getItemsPrimeTrancheAgeStatutBareme()

            this.setDefautValues();
          } else {
            this.itemsPrimeByProduitId = [];
          }
        },
        (err) => {
          this.itemsPrimeByProduitId = [];
        }
      );
  }
  getItemsPrimeTrancheAgeStatut() {
    if(!this.currentProduit.id)
      return
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        produit_id:this.currentProduit.id
        
      },
    };
    // debugger

    this.busyGet = this.restClient
      .post("primeProduitTrancheAgeStatut/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsPrimeByStatutAndTrancheAge = res["items"];
            this.onInputChange({})

          } else {
            this.itemsPrimeByStatutAndTrancheAge = [];
          }
        },
        (err) => {
          this.itemsPrimeByStatutAndTrancheAge = [];
        }
      );
  }
  getItemsPrimeTrancheAgeStatutBareme() {
    if(!this.currentProduit.id)
      return
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        produit_bareme_id:this.currentProduit.id
        
      },
    };
    // debugger

    this.busyGet = this.restClient
      .post("primeProduitTrancheAgeStatutBareme/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsPrimeByStatutAndTrancheAge = res["items"];
            this.onInputChange({})

          } else {
            this.itemsPrimeByStatutAndTrancheAge = [];
          }
        },
        (err) => {
          this.itemsPrimeByStatutAndTrancheAge = [];
        }
      );
  }

  setDefautValues() {
    if (!this.currentProduit.id) {
      this.itemsStatutInitialized.map((isi) => {
        if (isi.codification == "A") {
          isi.age_min = this.findValueInGlobalParams("age_min_assure") || 18;
          isi.age_max = this.findValueInGlobalParams("age_max_assure") || 70;
          isi.nombre_autorise = 1;
          isi.nombre_supplementaire_autorise = 0;
          isi.surprime_si_supplementaire = 0;
        }
        if (isi.codification == "C") {
          isi.age_min = this.findValueInGlobalParams("age_min_conjoint") || 18;
          isi.age_max = this.findValueInGlobalParams("age_max_conjoint") || 70;
          isi.nombre_autorise = 1;
          isi.nombre_supplementaire_autorise = 0;
          isi.surprime_si_supplementaire = 0;
        }
        if (isi.codification == "E") {
          isi.age_min = this.findValueInGlobalParams("age_min_enfant") || 0;
          isi.age_max = this.findValueInGlobalParams("age_max_enfant") || 21;
          isi.nombre_autorise = 4;
          isi.nombre_supplementaire_autorise = 0;
          isi.surprime_si_supplementaire = 0;
        }
        if (isi.codification == "ASC") {
          isi.age_min = this.findValueInGlobalParams("age_min_ascendant") || 60;
          isi.age_max =
            this.findValueInGlobalParams("age_max_ascendant") || 100;
          isi.nombre_autorise = 0;
          isi.nombre_supplementaire_autorise = 0;
          isi.surprime_si_supplementaire = 0;
        }
        if (isi.codification == "AU") {
          isi.age_min = 0;
          isi.age_max = 23;
          isi.nombre_autorise = 0;
          isi.nombre_supplementaire_autorise = 0;
          isi.surprime_si_supplementaire = 0;
        }
      });
    } else {

      //Mise à jour de la table des primes (sans les prime)
      if (this.itemsPrimeByProduitId && this.itemsPrimeByProduitId.length) {
        this.itemsPrimeByProduitId.map((ip) => {
          ip.codification =
            this.itemsStatut &&
            this.itemsStatut.filter((ig) => ig.id == ip.statut_id)
              ? this.itemsStatut.filter((ig) => ig.id == ip.statut_id)[0]
                  .codification
              : "";
        });

        this.itemsStatutInitialized.map((isi) => {
          if (isi.codification == "A") {
            let item = this.itemsPrimeByProduitId.filter((ip) => ip.codification == "A")[0];
            isi.prime = item.prime;
            isi.plafond = item.plafond;
            isi.age_min = item.age_min;
            isi.age_max = item.age_max;
            isi.nombre_autorise = item.nombre_autorise;
            isi.nombre_supplementaire_autorise =
              item.nombre_supplementaire_autorise;
            isi.surprime_si_supplementaire = item.surprime_si_supplementaire;
          }
          if (isi.codification == "C") {
            let item = this.itemsPrimeByProduitId.filter((ip) => ip.codification == "C")[0];
            isi.prime = item.prime;
            isi.plafond = item.plafond;
            isi.age_min = item.age_min;
            isi.age_max = item.age_max;
            isi.nombre_autorise = item.nombre_autorise;
            isi.nombre_supplementaire_autorise =
              item.nombre_supplementaire_autorise;
            isi.surprime_si_supplementaire = item.surprime_si_supplementaire;
          }
          if (isi.codification == "E") {
            let item = this.itemsPrimeByProduitId.filter((ip) => ip.codification == "E")[0];
            isi.prime = item.prime;
            isi.plafond = item.plafond;
            isi.age_min = item.age_min;
            isi.age_max = item.age_max;
            isi.nombre_autorise = item.nombre_autorise;
            isi.nombre_supplementaire_autorise =
              item.nombre_supplementaire_autorise;
            isi.surprime_si_supplementaire = item.surprime_si_supplementaire;
          }
          if (isi.codification == "ASC") {
            let item = this.itemsPrimeByProduitId.filter((ip) => ip.codification == "ASC")[0];
            isi.prime = item.prime;
            isi.plafond = item.plafond;
            isi.age_min = item.age_min;
            isi.age_max = item.age_max;
            isi.nombre_autorise = item.nombre_autorise;
            isi.nombre_supplementaire_autorise =
              item.nombre_supplementaire_autorise;
            isi.surprime_si_supplementaire = item.surprime_si_supplementaire;
          }
          if (isi.codification == "AU") {
            let item = this.itemsPrimeByProduitId.filter((ip) => ip.codification == "AU")[0];
            isi.prime = item.prime;
            isi.plafond = item.plafond;
            isi.age_min = item.age_min;
            isi.age_max = item.age_max;
            isi.nombre_autorise = item.nombre_autorise;
            isi.nombre_supplementaire_autorise =
              item.nombre_supplementaire_autorise;
            isi.surprime_si_supplementaire = item.surprime_si_supplementaire;
          }
        });
      }

      

      //Mise à jour de la table des prime par tranche d'age et statut
      this.itemsPrimeByStatutAndTrancheAge = this.itemToSave.itemsPrimeTrancheAgeStatut;
    }
    this.itemsStatutInitialized.sort((a, b) => this.customSort(a, b));
    this.get_nombre_par_famille();
    this.onInputChange({})
  }

  customSort(a, b) {
    const desiredOrder = ["ASSURE", "CONJOINT", "ENFANT", "ASCENDANT", "AUTRE"];
    return desiredOrder.indexOf(a.libelle) - desiredOrder.indexOf(b.libelle);
  }

  customSortTypeRembCodification(a, b) {
    const desiredOrder = ["TPRD", "TP", "RD", "TPG"];
    return (
      desiredOrder.indexOf(a.codification) -
      desiredOrder.indexOf(b.codification)
    );
  }

  
  

  get_nombre_par_famille() {
    let count: number = 0;
    this.itemsStatutInitialized.map((isi) => {
      const nombre = Number(isi.nombre_autorise) || 0; // If undefined, set to 0
      console.log(
        "isi.nombre_autorise: ",
        isi.nombre_autorise,
        "Converted:",
        nombre
      );
      count += nombre;
    });

    console.log("count: ", count);
    this.itemToSave.nombre_personnes_famille = count;
    console.log(
      "itemToSave.nombre_personnes_famille: ",
      this.itemToSave.nombre_personnes_famille
    );
  }

  
  onInputChange(event) {
    console.log('onInputChange')
    let reduce:any=[]
    if(this.itemsStatutInitialized && this.itemsStatutInitialized.length){
      reduce= this.itemsStatutInitialized.map(isi => ({
        statut_id: isi.id,
        garant_id: isi.garant_id,
        prime: isi.prime,
        plafond: isi.plafond,
        surprime_si_supplementaire: isi.surprime_si_supplementaire,
        nombre_supplementaire_autorise: isi.nombre_supplementaire_autorise,
        nombre_autorise: isi.nombre_autorise,
        age_min: isi.age_min,
        age_max: isi.age_max,
        codification: this.generateUniqueString(),
        code: this.generateUniqueString(),
      }));
    }
    
    if(this.itemsPrimeByStatutAndTrancheAge && this.itemsPrimeByStatutAndTrancheAge.length){
      this.itemsPrimeByStatutAndTrancheAge.map(ipbta=>{
        ipbta.codification= this.generateUniqueString()
        ipbta.code= this.generateUniqueString()
      })
    }
    

    let obj = {
      configPlafondTaStatut:reduce,
      primesTrancheAgeStatut:this.itemsPrimeByStatutAndTrancheAge
      
    }
    this.onChangePrimeTrancheAgeStatutForm.emit(obj);
  }

  ngOnInit() {
    this.getItemsParametreSysteme();
    this.getItemsStatut();
  
  }

}
